export interface ValidationResult{
    state: boolean,
    message: string
}

export interface ValidationModel {
    rules: ValidationRule[],
    state: boolean | null,
    message: string | null,
    value: any,
    active: boolean
}

export interface ValidationRule{
    type: ValidationType,
    value?: any
}

export enum ValidationType{
    Required,
    Min,
    Max,
    Confirm,
    Number,
    URL,
    NonNegativeNumber,
    UniqueEmail
}
